import React from "react";
import loadable from "@loadable/component";
import FilterSockImage from "assets/images/performanceRefresh/filterSock/mila-sock-without.png";
import FilterSockImageWebp from "assets/images/performanceRefresh/filterSock/mila-sock-without.png?as=webp";

const ImageLoader = loadable(() => import("../common/ImageLoader"));

function FilterSock() {
  return (
    <section className="p-filter-sock">
      <div className="container">
        <div className="p-filter-sock__header">
          <h2 className="p-filter-sock__title">
            She even comes with stylish lil’ socks ...
          </h2>
          <div className="p-filter-sock__description">
            <p>
              Yep, Mila wears socks—washable filter wraps that work as a
              pre-filter to capture larger particles. They’ll extend the life of
              your filter, and are easy to clean and reuse.
            </p>
          </div>
        </div>
        <ImageLoader
          image={FilterSockImage}
          webp={FilterSockImageWebp}
          alt="Filter Sock"
          className="p-filter-sock__image"
          placeholderAspectRatio={906 / 656}
        />
      </div>
    </section>
  );
}

export default FilterSock;
